import {createReducer, on} from '@ngrx/store';
import {ZahlungsprotokollState} from '../../interfaces/zahlungsprotokoll-state.interface';
import {ZahlungsprotokollActions} from '../actions/zahlungsprotokoll.actions';


export const initialZahlungsprotokollState: ZahlungsprotokollState = {
  loading: false,
  isDialogOpen: false,
};

export const zahlungsprotokollReducer = createReducer(
  initialZahlungsprotokollState,

  on(
    ZahlungsprotokollActions.openZahlungsprotokoll,
    (state, action) => ({
      ...state,
      loading: true,
      inhaberId: action.inhaberId,
      zahlungslaufId: action.zahlungslaufId,
      content: undefined,
      filename: undefined,
    })
  ),

  on(
    ZahlungsprotokollActions.loadZahlungsprotokollSuccess,
    (state, action) => ({
      ...state,
      loading: false,
      isDialogOpen: true,
      zahlungslaufId: action.zahlungslaufId,
      content: action.content,
      filename: action.filename,
    })
  ),

  on(
    ZahlungsprotokollActions.loadZahlungsprotokollFailure,
    state => ({
      ...state,
      loading: false,
      isDialogOpen: false,
    })
  ),

  on(
    ZahlungsprotokollActions.closeZahlungsprotokollDialog,
    state => ({
      ...state,
      isDialogOpen: false,
      content: undefined,
      filename: undefined,
    })
  ),
);
